import { ReserveInStoreLine } from '@utils/gtm-tracking/utils/mapToReserveInStore';

export type ReserveInStoreEvent = {
    event: 'reserve_in_store';
    ecommerce: {
        selected_store: string;
        transaction_id: string;
        reserved_item_value: number;
        reserved_items: ReserveInStoreLine[];
    };
};

/**
 * Track the reserve in store event in GTM
 *
 * NOTE: due to an lack of the total of reservation field in database structure
 * we need to calculate the total price of the reserved items in the FE,
 * because the BE does not send the total price of the reserved items.
 * @param userId
 * @param store
 * @param transactionId
 * @param total - total price of the reserved items (if it's 0, we calculate it in the FE)
 * @param reservedItems
 */
export const trackReserveInStoreEvent = (
    store: string,
    transactionId: string,
    total: number,
    reservedItems: ReserveInStoreLine[]
): ReserveInStoreEvent => ({
    event: 'reserve_in_store',
    ecommerce: {
        selected_store: store,
        transaction_id: transactionId,
        reserved_item_value:
            total !== 0
                ? total
                : reservedItems.reduce((acc, item) => acc + item.reserved_item_quantity * item.reserved_price, 0),
        reserved_items: reservedItems
    }
});
